import React, { useState } from "react";
import { useQuery } from "react-query";
import { handleUserSubscriptions } from "../../axios";
import { useSelector } from "react-redux";
import SubscriptionsTable from "./SubscriptionsTable";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";

const list = [
  {
    name: "All",
  },
  {
    name: "Active",
  },
  {
    name: "In Active",
  },
  {
    name: "Canceled",
  },
  {
    name: "Free",
  },
];

const Subscriptions = () => {
  const { token } = useSelector((state) => state.auth);
  const [selected, setSelected] = useState(list[0]?.name);
  const navigate = useNavigate();

  const handleSubscriptionClick = (name) => {
    setSelected(name);
  };

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  const {
    data: subscriptions,
    isLoading: subscriptionsLoading,
    isSuccess: subscriptionsSuccess,
    isError,
  } = useQuery(["subscriptions"], () => handleUserSubscriptions(config));

  return (
    <div>
      <div className="flex items-center justify-between">
        <p className="font-semibold antialiased tracking-wide text-[22px]">
          Subscriptions
        </p>
        <button
          onClick={() => navigate(-1)}
          className="bg-black text-white h-10 w-[130px] rounded-[8px] flex justify-center items-center gap-2 hover:ring-2 hover:ring-gray-300 transition-all duration-300"
        >
          <ArrowLeftIcon />
          <p>Back</p>
        </button>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 mt-5 gap-10">
        {list.map((item, index) => (
          <div
            className={`ring-2 ring-gray-200 p-3 rounded-[8px] transition-all duration-300 cursor-pointer hover:ring-2 hover:ring-purple-600 ${
              selected === item.name && "ring-2 ring-purple-600"
            }`}
            key={index}
            onClick={() => handleSubscriptionClick(item.name)}
          >
            <p>{item.name}</p>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <SubscriptionsTable
          data={subscriptions?.data}
          selected={selected}
          loading={subscriptionsLoading}
        />
      </div>
    </div>
  );
};

export default Subscriptions;
